const secondsToMilliseconds = (seconds) => seconds * 1e3;
function millisecondsToSeconds(milliseconds) {
  return milliseconds / 1e3;
}
export {
  millisecondsToSeconds,
  secondsToMilliseconds
};
